"use client";

import { useBuySellDialog, useClaimDialog } from "@/stores/global-dialogs.atoms";
import { RESET } from "jotai/utils";
import { OrderDialogV2 } from "../common/order-dialog-v2/order-dialog-v2";
import { ClaimDialog } from "./claim-dialog";

export function GlobalDialogs() {
    const [buySellDialog, setBuySellDialog] = useBuySellDialog();
    const [claimDialog, setClaimDialog] = useClaimDialog();

    return (
        <>
            <OrderDialogV2
                state={buySellDialog}
                onStateChange={(v) => {
                    if (v === undefined) setBuySellDialog(RESET);
                    else setBuySellDialog(v);
                }}
            />
            <ClaimDialog
                claims={claimDialog}
                onClaimsChange={(v) => {
                    if (v === undefined) setClaimDialog(RESET);
                    else setClaimDialog(v);
                }}
            />
        </>
    );
}
